import { MainInner, MainSection, StyledMainSection } from "@/styles/global";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

const Section = styled(StyledMainSection)``;

const LogoLink = styled.a``;

const LogoLinkInternal = styled(Link)``;

const LogoWrapper = styled.div``;

const Logo = styled(GatsbyImage)`
  width: 100%;
  height: 100%;
  max-width: 140px;
  max-height: 140px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    max-width: 200px;
    max-height: 140px;
  }
`;

const S = {
  Section,
  LogoLink,
  LogoLinkInternal,
  LogoWrapper,
  Logo,
};

export default S;
